import Header from './components/Header';
import Hero from './components/Hero';
import Overview from './components/Overview';
import ColorVariants from './components/ColorVariants';
import Features from './components/Features';
import Gallery from './components/Gallery';
import Reservation from './components/Reservation';
import MilitaryCredibility from './components/MilitaryCredibility';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import StickyReserveCTA from './components/StickyReserveCTA';
import ImageShowcase from './components/ImageShowcase';
import SeoJsonLd from '../../components/feature/SeoJsonLd';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <SeoJsonLd />
      <Header />
      <Hero />
      <MilitaryCredibility />
      <Gallery />
      <Overview />
      <ColorVariants />
      <Features />
      <Reservation />
      <Testimonials />
      <FAQ />
      <ImageShowcase />
      <CTA />
      <StickyReserveCTA />
    </div>
  );
}
